import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { useAuth } from '../hooks/useAuth'

const IndexPage = () => {
  const navigate = useNavigate()
  const { isAuthenticated, loginWithUsernameAndPassword, accessDenied, hasInvite, loading } = useAuth()
  const isNative = Capacitor.isNativePlatform()

  useEffect(() => {
    if (sessionStorage.getItem('logging_out')) return
    if (isAuthenticated) {
      navigate('/react/dashboard')
    } else if (hasInvite) {
      navigate('/auth/register')
    } else if (isNative) {
      // Wait for native session restore attempt before forcing login screen
      if (loading.query) return
      navigate('/auth/login')
    } else if (!accessDenied) {
      loginWithUsernameAndPassword('', '')
    }
  }, [isAuthenticated, accessDenied, hasInvite, isNative, loading.query])

  return null
}

export default IndexPage
